import type { ComponentProps } from 'react';
import React from 'react';
import { useExternalBrandLogoIcon } from './ExternalBrandLogo';
import SVGIcon from './SVGIcon';
import apiIcon from '../icons/non-prefilled/16x16/api.svg';
import getExternalBrandLogoProps from '../integrations/getExternalBrandLogoProps';

interface ExternalPostPlatformIconProps
  extends Omit<ComponentProps<typeof SVGIcon>, 'children'> {
  id: string;
}

const ExternalPostPlatformIcon = ({
  id,
  ...props
}: ExternalPostPlatformIconProps) => {
  const logoIcon = useExternalBrandLogoIcon(getExternalBrandLogoProps(id));
  return <SVGIcon {...props}>{logoIcon ?? apiIcon}</SVGIcon>;
};

export default ExternalPostPlatformIcon;
